import API_BASE_URL from "../../../../../Constants";

export const fetchManagementCompaniesService = async (page, size, query) => {
  const queryString = query ? `&q=${encodeURIComponent(query)}` : "";
  const response = await fetch(
    `${API_BASE_URL}/api/setup/managementcompanies?page=${
      page - 1
    }&size=${size}${queryString}`,
    { credentials: "include" }
  );
  if (!response.ok) throw new Error("Network response was not ok");
  return response.json();
};

export const fetchManagementCompanies = async (
  page,
  size,
  query,
  sortField,
  sortOrder
) => {
  const queryString = query ? `&q=${encodeURIComponent(query)}` : "";
  const sortString =
    sortField && sortOrder
      ? `&sortField=${encodeURIComponent(
          sortField
        )}&sortOrder=${encodeURIComponent(sortOrder)}`
      : "";
  const response = await fetch(
    `${API_BASE_URL}/api/setup/managementcompanies?page=${
      page - 1
    }&size=${size}${queryString}${sortString}`,
    { credentials: "include" }
  );
  if (!response.ok) throw new Error("Network response was not ok");
  return response.json();
};

export const fetchAllCompanies = async () => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/managementcompanies/all`,
    { credentials: "include" }
  );
  if (!response.ok) throw new Error("Network response was not ok");
  return response.json();
};

export const fetchRelatedData = async (managementId) => {
  try {
    const contactsResponse = await fetch(
      `${API_BASE_URL}/api/setup/mgmtco-contact-intersections/management-company/${managementId}`,
      { credentials: "include" }
    );
    if (!contactsResponse.ok) {
      throw new Error("Error fetching contacts for management company");
    }
    const contactsData = await contactsResponse.json();
    return {
      contacts: Array.isArray(contactsData) ? contactsData : [],
    };
  } catch (error) {
    console.error("Error fetching related data:", error);
    throw error;
  }
};

export const updateManagementCompany = async (managementId, data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/managementcompanies/${managementId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("Failed to save management company:", error);
    throw error;
  }
};

// Fetch all contacts that can be assigned to a management company
export const fetchAllContacts = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/get-all`, {
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to fetch contacts");
  const allContacts = await response.json();

  // // Filter contacts with contactLevel of MANAGEMENT_COMPANY
  // const filteredContacts = allContacts.filter(
  //   (contact) => contact.contactLevel === CONTACT_LEVELS.MANAGEMENT_COMPANY
  // );

  return allContacts;
};

// Fetch assigned contacts for a specific management company
export const fetchAssignedContacts = async (managementId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/mgmtco-contact-intersections/management-company/${managementId}`,
    {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch assigned contacts");
  return response.json();
};

// Update the list of assigned contacts for a management company
export const updateAssignedContacts = async (managementId, contacts) => {
  const contactsDto = contacts.map((contact) => ({
    contactId: contact.contactID,
    managementCompanyId: managementId,
    mainContact: contact.mainContact || false,
    agentContact: contact.agentContact || false,
    collectionsContact: contact.collectionsContact || false,
  }));
  const response = await fetch(
    `${API_BASE_URL}/api/setup/mgmtco-contact-intersections/update/${managementId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(contactsDto),
    }
  );
  if (!response.ok) throw new Error("Failed to update assigned contacts");
};

export const deleteManagementCompany = async (managementId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/managementcompanies/deleteManagementCompany/${managementId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  const message = await response.text();
  if (!response.ok) throw new Error(message);

  return message;
};

export const addNewContact = async (contactData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(contactData),
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to add contact");
  }

  return response.json();
};

export const updateContact = async (contactId, contactData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/contacts/${contactId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactData),
      credentials: "include",
    }
  );
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update contact");
  }
  return response.json();
};
